/* global axios */
import ApiClient from './ApiClient';

class ZapiAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/zapi/status`);
  }

  getQrCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/zapi/qr_code`);
  }

  getPhoneCode(inboxId, phone) {
    return axios.get(`${this.url}/${inboxId}/zapi/phone_code`, {
      params: { phone },
    });
  }

  restart(inboxId) {
    return axios.post(`${this.url}/${inboxId}/zapi/restart`);
  }

  updateProfile(inboxId, profileData) {
    return axios.put(`${this.url}/${inboxId}/zapi/profile`, profileData);
  }

  updateWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/zapi/update_webhook`);
  }

  getDevice({ idZapi, tokenZapi, clientZapi }) {
    const baseUrl = this.url.replace('/inboxes', '/zapi_device');
    return axios.get(baseUrl, {
      params: {
        id_zapi: idZapi,
        token_zapi: tokenZapi,
        client_zapi: clientZapi,
      },
    });
  }
}

export default new ZapiAPI();
